import * as Input from "../../components/Form/Input";
import { Button } from "../../components/Button";
import { Eye } from "lucide-react";
import { useLoading } from "../../store/useLoading";
import { useStore } from "../../store";
import { toast } from "react-toastify";
import api from "../../service/api";
import { useEffect, useState } from "react";
import { Loading } from "../../components/Loading";
import { EmptyList } from "../../components/EmptyList";
import { ITickets } from "../../@types/system";
import { formatMoney } from "../../utils/formatMoney";

export function ListIngressos() {
  const loading = useLoading((store) => store.isLoading);
  const setLoading = useLoading((store) => store.setLoading);
  const tickets = useStore((store) => store.tickets);
  const setTickets = useStore((store) => store.setTickets);

  const [showtikects, setShowtikects] = useState(false);
  const [tikects, setTikects] = useState({} as ITickets);

  async function getData() {
    setLoading(true);
    try {
      const res = await api.get(`/tickets`);
      setTickets(res.data);
    } catch (error) {
      toast.error("Erro ao tentar carregar os dados, recarregue a página", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getData();
  }, []);

  function handleShowAction(tickets: ITickets) {
    setShowtikects(true);
    setTikects(tickets);
  }
  function handleCancel() {
    setShowtikects(false);
  }


  return (
    <>
      {loading && <Loading />}
      {!loading && tickets.length === 0 && <EmptyList />}
      {!loading && !showtikects && tickets.length > 0 && (
        <ul
          role="list"
          className="divide-y divide-gray-100  dark:divide-zinc-800"
        >
          {tickets.map((ticket) => (
            <li key={ticket.id} className="flex flex-col gap-3 py-5 sm:flex-row sm:justify-between sm:gap-x-6">
              <div className="flex min-w-0 gap-x-4">
                {/* <img className="h-12 w-12 flex-none rounded-full bg-gray-50" src={person.imageUrl} alt="" /> */}
                <div className="min-w-0 flex-auto">
                  <p className="text-sm font-semibold leading-6 text-gray-900  dark:text-white">
                    <span className="text-sm font-normal text-gray-600">Evento: </span> {ticket.event.name}
                  </p>
                  <p className="mt-1 truncate text-xs leading-5 text-gray-500 dark:text-zinc-400">
                    Valor: {formatMoney(ticket.value)}
                  </p>
                </div>
              </div>
              <div className="shrink-0 sm:flex sm:items-center gap-x-1">
                <Button
                  type="button"
                  variant="outline"
                  title="Visualizar Detalhes"
                  onClick={() => handleShowAction(ticket)}
                >
                  <Eye className="h-4 w-4 text-zinc-400" strokeWidth={3} />
                </Button>
              </div>
            </li>
          ))}
        </ul>
      )}
      {showtikects && (
        <>
          <form
            id="clients"
            className="mt-6 flex w-full flex-col gap-5 divide-y divide-zinc-200 dark:divide-zinc-800"
          >
            <div className="grid gap-3 pt-5 lg:grid-cols-form">
              <label
                htmlFor="name"
                className="text-sm font-medium text-zinc-700 dark:text-zinc-100"
              >
                Evento
              </label>
              <div className="flex gap-3">
                <Input.Root className={showtikects ? "bg-zinc-100" : ""}>
                  <Input.Control
                    id="name"
                    type="text"
                    name="name"
                    placeholder="Nome"
                    value={`${tikects.event.name}`}
                    disabled={showtikects}
                  />
                </Input.Root>
              </div>
            </div>

            <div className="grid gap-3 pt-5 lg:grid-cols-form">
              <label
                htmlFor="cnpj"
                className="text-sm font-medium text-zinc-700 dark:text-zinc-100"
              >
                Valor
              </label>
              <div className="flex gap-3">
                <Input.Root className={showtikects ? "bg-zinc-100" : ""}>
                  <Input.Control
                    id="cnpj"
                    type="text"
                    name="phone"
                    placeholder="Telefone"
                    value={`${formatMoney(tikects.value)}`}
                    disabled={showtikects}
                  />
                </Input.Root>
              </div>
            </div>

            <div className="flex items-center justify-end gap-2 pt-5">
              <Button type="button" variant="outline" onClick={handleCancel}>
                Voltar
              </Button>
            </div>
          </form>
        </>
      )}
    </>
  );
}
